import React, { useEffect, useState } from "react";
import "./procced.css";
import { useNavigate } from "react-router-dom";
import proArrow from "../assets/proArrow.png"
import { getDigitalStatus } from "../Utils/getDigitalStatus"
import logger from "../Utils/logger";


const Procced = ({ bottom,cartCount, totalAmount, preCart, page,items,isSample ,pdp,productDetailsData }) => {
  const [sampleItem,setSampleItem]=useState(null)
  logger.log("isSample",isSample)
    const navigate = useNavigate();
    
 
 logger.log("items----",pdp,productDetailsData?.isSample,preCart)
 
 const result = preCart?.map(cartItem => {
  const matchedItem = items?.find(
    i => Number(i?.slot_id) === Number(cartItem?.slotId)
  );

const digitalStatus = getDigitalStatus(preCart);
logger.log("digitalStatus", digitalStatus);  

  return {
    cart: cartItem,
    item: matchedItem || null
  };
});





  function pdpcalculateFinalPrice(item) {
    logger.log("pdpcalculateFinalPrice+++++++++",item)
  const mvOfferPrice = item?.mvOfferPrice || 0;
  const offerDetails = item?.offer_details;


  
  // ❌ No offer OR not a Discount coupon
  if (!offerDetails || offerDetails.couponType !== "Discount") {
    return mvOfferPrice;
  }

  const { flatTypeId, flatAmount } = offerDetails;

  let discount = 0;

  if (flatTypeId === 1) {
    // Flat amount (₹)
    discount = flatAmount || 0;
  } else if (flatTypeId === 2) {
    // Percentage (%)
    discount = (mvOfferPrice * (flatAmount || 0)) / 100;
  }

  const finalPrice = mvOfferPrice - discount;

  return Math.max(finalPrice, 0);
} 

 function calculateFinalPrice(item) {
  const offerPrice = item?.offer_price || 0;
  const offerDetails = item?.offer_details;

  // ❌ No offer OR not a Discount coupon
  if (!offerDetails || offerDetails.couponType !== "Discount") {
    return offerPrice;
  }

  const { flatTypeId, flatAmount } = offerDetails;

  let discount = 0;

  if (flatTypeId === 1) {
    // Flat amount (₹)
    discount = flatAmount || 0;
  } else if (flatTypeId === 2) {
    // Percentage (%)
    discount = (offerPrice * (flatAmount || 0)) / 100;
  }

  const finalPrice = offerPrice - discount;

  return Math.max(finalPrice, 0);
}
  const goMyCart = () => {
    const machineId=localStorage.getItem("machineId")
   
    localStorage.setItem("mycart", true);

 /*    mpCartClicked({
      EventName: mixpanelEvent,
      data: { ItemsInCart: cartItemsList, TotalCartValue: totalAmount },
    }); */
    navigate(`/myCart?machineId=${machineId}`,);
     
  };
logger.log("+++++++++++++++++++++",productDetailsData?pdpcalculateFinalPrice(productDetailsData):"zero")
  const price = productDetailsData
  ? (productDetailsData.isSample
      ? pdpcalculateFinalPrice(productDetailsData)
      : totalAmount)
  : (isSample === "true"
      ? calculateFinalPrice(result?.[0]?.item)
      : totalAmount);

  return (
    <div className="proccedModal" style={{ bottom: bottom || "0px" }}>
      <div className="proccedBox">
        <div className="proccedContent">
          <div className="cartInfo">
   <h3>
  {preCart?.reduce((total, item) => total + (item?.count || 0), 0) || 0}
  {" "}Item
  {(preCart?.reduce((total, item) => total + (item?.count || 0), 0) || 0) !== 1
    ? "s"
    : ""}
  <span className="cartValue">
     {" "}₹{Number(price || 0).toFixed(2)}
  </span>
</h3>
          </div>

          <div className="divider"></div>

          <button className="proceedBtn" onClick={goMyCart}>
            <span>Proceed To Pay</span>
            <img src={proArrow} alt="arrow" className="arrowIcon" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Procced;
